import { useOutletContext } from "react-router";

import { ClientContent, ClientTabBase } from "@shared";

import { ClientDetailResponse } from "@/api";
import { ClientStatusWidget } from "@/pages/clients/client/components/client-status-widget/ClientStatusWidget";

import { ClientCurrentAgreementOverview } from "./components/current-agreement-overview/ClientCurrentAgreementOverview";
import { ClientDebtOverview } from "./components/debt-overview/ClientDebtOverview";
import { useClientOverview } from "./hooks/useClientOverview";

export function OverviewTab() {
  const client = useOutletContext<ClientDetailResponse>();
  const { formik, lastAgreement } = useClientOverview(client);

  return (
    <ClientTabBase navigation={<></>} navigationFooter={<ClientStatusWidget client={client} />}>
      <ClientContent formik={formik}>
        <ClientCurrentAgreementOverview lastAgreement={lastAgreement} />
        <ClientDebtOverview clientId={client.clientId} formik={formik} />
      </ClientContent>
    </ClientTabBase>
  );
}
